import { ConfigurationType } from 'data/types';
import { linesetHasPointLevels } from 'utils/lineset-point-levels';

type GridPoint = { x: number; y: number };

export function syncCondenserLinesetAnchors(
  config: ConfigurationType,
  condenserUniqueId: string,
  centerPosition: GridPoint,
  levelUniqueId: string | undefined
): void {
  if (!config.lineSets) return;
  for (const lineset of config.lineSets) {
    if (
      lineset.condenserUniqueId === condenserUniqueId &&
      lineset.points.length > 0
    ) {
      const anchorPoint = lineset.points[0];
      anchorPoint.positionX = centerPosition.x;
      anchorPoint.positionY = centerPosition.y;
      if (levelUniqueId) {
        if (linesetHasPointLevels(lineset)) {
          anchorPoint.levelUniqueId = levelUniqueId;
        }
        lineset.condenserLevelUniqueId = levelUniqueId;
        if (lineset.airHandlerLevelUniqueId) {
          lineset.isCrossFloor =
            levelUniqueId !== lineset.airHandlerLevelUniqueId;
        }
      }
    }
  }
}

export function syncAirHandlerLinesetAnchors(
  config: ConfigurationType,
  airHandlerUniqueId: string,
  centerPosition: GridPoint,
  levelUniqueId: string | undefined
): void {
  if (!config.lineSets) return;
  for (const lineset of config.lineSets) {
    if (
      lineset.airHandlerUniqueId === airHandlerUniqueId &&
      lineset.points.length > 0
    ) {
      const anchorPoint = lineset.points[lineset.points.length - 1];
      anchorPoint.positionX = centerPosition.x;
      anchorPoint.positionY = centerPosition.y;
      if (levelUniqueId) {
        if (linesetHasPointLevels(lineset)) {
          anchorPoint.levelUniqueId = levelUniqueId;
        }
        lineset.airHandlerLevelUniqueId = levelUniqueId;
        if (lineset.condenserLevelUniqueId) {
          lineset.isCrossFloor =
            levelUniqueId !== lineset.condenserLevelUniqueId;
        }
      }
    }
  }
}
